export const LOAD_REQUESTED = "APPROVAL_HISTORY_MODAL/LOAD_REQUESTED";
export const LOAD_SUCCESS = "APPROVAL_HISTORY_MODAL/LOAD_SUCCESS";
export const LOAD_FAIL = "APPROVAL_HISTORY_MODAL/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return { ...state, loading: true };
    }
    case LOAD_SUCCESS: {
        return { ...state, loading: false, data, error: null };
    }
    case LOAD_FAIL: {
        return { ...state, loading: false, data: null, error: data };
    }
    default:
        return state;
    }
};

export const requestLoadApprovalHistoryModal = data => ({
    type: LOAD_REQUESTED,
    data,
});
export const successLoadApprovalHistoryModal = data => ({
    type: LOAD_SUCCESS,
    data,
});
export const failLoadApprovalHistoryModal = data => ({
    type: LOAD_FAIL,
    data,
});
